import axios from 'axios'
import {SKIP_AUTH} from 'navigation/RouteManager'
import storage from './storage'
import moment from 'moment'
import {serverPhoneFormat} from './utils/apiUtils'

export const DEV_URL = 'https://Tomy-api.familybiz.co.il'
export const PROD_URL = 'https://Kita-api.familybiz.co.il'
export const APP_URL = 'https://App-api.familybiz.co.il'

const SERVER_URL =
    process.env.REACT_APP_API_HOST ||
    window.location.protocol +
        '//' +
        window.location.host.replace('planners', 'api')
const BASE_URL = SERVER_URL + '/api' //'/api/v1' //'http://localhost:3300/'
const HEADERS = {
    'Content-Type': 'application/json',
}

class Api {
    constructor() {
        this.baseUrl = BASE_URL
        this.authMonitor = setInterval(() => {
            const expire = storage.getLoginCredentials()?.expire
            if (expire) {
                const diffInSec = moment(expire).diff(moment()) / 1000
                if (diffInSec < 70 && diffInSec >= 60) {
                    const shouldRefresh = window.confirm(
                        'עדיין פה? אנחנו הולכים לנתק אותך בשניות הקרובות'
                    )
                    if (shouldRefresh) {
                        this.reLoginWithRefreshToken()
                    }
                } else if (diffInSec < 0) {
                    storage.setLoginCredentials(null)
                    window.location.reload()
                }
            }
        }, 10000)
    }

    destructor() {
        clearInterval(this.authMonitor)
    }

    async request(
        url,
        method,
        params,
        data,
        headers = {},
        onSuccess
        // rememberMe = storage.getRememberMe()
    ) {
        const rememberMe = storage.getRememberMe()
        try {
            const response = await axios.request({
                headers: {...HEADERS, ...headers},
                withCredentials: true,
                baseURL: this.baseUrl,
                method,
                url,
                data,
                params,
            })

            console.log('axios response', {response})
            onSuccess?.(response?.data)
            return response?.data
        } catch (error) {
            console.error('axios error', {error})
            // onError && (await onError(error))
            if (
                error?.status === 401 &&
                url !== 'auth/refreshToken' &&
                rememberMe === 'true'
            ) {
                return await this.reLoginWithRefreshToken(error)
            }
        }
    }

    async addUser(email, password, name) {
        return this.request('users/signup', 'POST', null, {
            email,
            password,
            name,
        })
    }
    async getCurrentUser() {
        return this.request(`auth/getCurrentUser`, 'GET')
    }

    async login(username, password = null, refreshToken = null) {
        console.log('main login', username)
        new Promise((resolve, reject) => {
            const passOrToken = password
                ? `&password=${password}&grant_type=password`
                : `&refresh_token=${refreshToken}&grant_type=refresh_token`
            const params = `username=${serverPhoneFormat(
                username
            )}${passOrToken}`
            this.lastTokenRequest = Date.now()

            this.request(
                this.baseUrl.replace('api/', '') + 'token',
                'POST',
                params,
                false
            ).then(
                (response) => {
                    // if (response.error) return resolve(response);

                    console.log('login response', response)
                    if (response.access_token) {
                        this.bearerToken = response.access_token
                        this.bearerTokenExpiresIn = response.expires_in

                        storage.updateLoginCredentials({
                            token: response.access_token,
                            name:
                                response.uFirstName + ' ' + response.uLastName,
                            gender: response.uGender,
                            username: response.aemail,
                            userId: response.aid,
                            expire: moment(response['.expires']).format(),
                            refreshToken: response.refresh_token,
                            tokenReceivedTimeStamp: Date.now(),
                        })
                    } else {
                        reject('failed login')
                        return
                    }
                    return resolve(response)
                },
                (error) => reject(error)
            )
        })
    }

    // async login(email, password) {
    //     return this.request(`auth/login`, 'POST', null, {email, password})
    // }

    async logout() {
        return this.request('auth/logout', 'POST')
    }

    async uploadFile(formData, bucket, folder) {
        return this.request('/upload', 'POST', {bucket, folder}, formData, {
            'Content-Type': 'multipart/form-data',
            ...formData.getHeaders(),
        })
    }

    async forgotPassword(email) {
        return this.request('auth/forgotPassword', 'POST', null, {email})
    }

    async refreshToken() {
        return this.request('auth/refreshToken', 'GET')
    }

    async test() {
        return this.request('auth/refreshToken', 'GET')
    }

    async reLoginWithRefreshToken(err) {
        const originalReq = err?.config
        console.log('message: ', originalReq)

        if (
            err.response?.status === 401 &&
            originalReq.url === 'auth/refreshToken'
        ) {
            return
        }

        try {
            await this.refreshToken()
            const originalReq = err?.config
            if (originalReq) {
                return await this.request(
                    originalReq.url,
                    originalReq.method,
                    originalReq.params,
                    originalReq.data,
                    originalReq.headers,
                    null,
                    null
                )
            }
        } catch (err) {
            console.error('refresh error: ', err)
            if (!SKIP_AUTH) {
                window.location.href = '/login'
            }
        }
    }
}
const api = new Api()
export default api
